import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-about-us-guide',
    standalone: true,
    imports: [CommonModule, TranslateModule, MatIcon],
    templateUrl: './about-us-guide.component.html',
    styleUrl: './about-us-guide.component.scss',
})
export class AboutUsGuideComponent {
    constructor(public translateService: TranslateService) {}

    get currentLang(): string {
        return this.translateService.currentLang;
    }

    switchedLanguage(data: string) {
        this.translateService.use(data);
    }

    imsmeUrl: string = 'http://imsme.com.my/';

    navigateToImsme(): void {
        window.open(this.imsmeUrl, '_blank');
    }

    faqs = [
        {
            subTitleEN:"",
            subTitleBM:"",
            questionEN: 'Applying for the right financing/loan',
            questionBM: 'Memohon untuk pembiayaan/pinjaman yang sesuai',
            answerEN: [
                'Identify your ability to repay the financing/loan​',
                'Determine the amount your business needs​',
                'Ensure that your business revenue can cover both your operating expenses and the loan repayment​',
                'Prepare the required documentation​',
                'Look for the right product match on imsme.com.my or use their product matching tool​',
                'Register for a user account and apply.',
            ],
            answerBM: [
                'Kenalpasti jumlah yang anda boleh bayar balik',
                'Kenalpasti jumlah keperluan untuk perusahaan anda',
                'Pastikan jumlah pendapatan perniagaan dapat menanggung perbelanjaan operasi dan bayaran balik pembiayaan/pinjaman anda',
                'Sediakan dokumen yang diperlukan',
                'Cari produk pembiayaan yang bersesuaian di imsme.com.my',
                'Daftar akaun pengguna dan mohon.',
            ],
        },
        {
            subTitleEN:"Requirements required by most banks when processing a SME business financing/loan application include:​",
            subTitleBM:"Antara syarat kelayakan pembiayaan/pinjaman termasuk:​",
            questionEN: 'Meeting the financing/loan eligibility requirements',
            questionBM:
                'Menepati keperluan pembiayaan/pinjaman',
            answerEN: [
                'Applicant must be a Malaysian citizen aged 21 years and above​',
                'The business must be registered and/ or licensed in Malaysia​​',
                'The business entity consist of either of Sole Proprietorship/ Partnership/ Limited Liability Partnership/Sendirian Berhad/ Individual/ Professional Bodies​',
                'The business has been in operations for at least three (3) years.​​',
            ],
            answerBM: [
                'Warganegara Malaysia yang berumur 21 tahun dan ke atas​',
                'Perniagaan yang berdaftar dan/ atau berlesen di Malaysia​',
                'Entiti perniagaan terdiri daripada Pemilikan Tunggal/ Perkongsian/ Perkongsian Liabiliti Terhad/ Sendirian Berhad/ Individu/ Badan Profesional',
                'Perniagaan sekurang-kurangnya telah beroperasi selama tiga (3) tahun',
            ],
        },
        {
            subTitleEN:"Factors which may influence your eligibility include:",
            subTitleBM:"Faktor yang dapat menentukan kelayakan permohonan anda termasuk:",
            questionEN:
                'How do financial institutions evaluate eligible applicants?',
            questionBM:
                'Menentukan kelayakan pembiayaan/ pinjaman perniagaan​',
            answerEN: [
                'Ability to repay your financing/loan',
                'Showing stable business revenue or consistent profits.​',
            ],
            answerBM: [
                'Rekod pembayaran balik​',
                'Kestabilan pendapatan perniagaan.​​',
            ],
        },
    ];

    openIndex: number | null = null;

    toggleAccordion(index: number): void {
        this.openIndex = this.openIndex === index ? null : index;
    }
}
